import { WorkingWithUsSectionStyles } from '../section.style';
import { ContentBlock } from '@exploration/shared-components';
import { useForceBreakpoint } from '@exploration/ui-utils';

const { Container, Content, VideoHolder, Video } = WorkingWithUsSectionStyles;

export interface GenuineConversationsProps {
  headline: string;
  subHeadline: string;
  content: string[];
  video: {
    description: string;
    qumuVideoId: string;
    title: string;
  };
  image: {
    alt: string;
    source: {
      publicUrl: string;
    };
  };
}

const GenuineConversations = ({
  headline,
  subHeadline,
  content,
  video,
  image,
}: GenuineConversationsProps) => {
  const { title, description, qumuVideoId } = video;
  const { source, alt } = image;
  Container.defaultProps = {
    forceMobileBreakpoint: useForceBreakpoint() === 'mobile',
  };

  return (
    <Container>
      <ContentBlock
        headline={headline}
        subHeadline={subHeadline}
        checkMarkItems={content}
      />
      <Content>
        <VideoHolder>
          <Video
            videoId={qumuVideoId}
            image={{
              ...image,
              alt: alt,
              src: source.publicUrl,
            }}
            captionText={description}
            titleText={title}
          />
        </VideoHolder>
      </Content>
    </Container>
  );
};

export default GenuineConversations;
